export interface IDeduction {
  name: string;
  description: string;
  amount: number;
  frequency: number;
  startDate: string;
  endDate: string;
  applicationDate: string;
  status: string;
}

export const DeductionInitial: IDeduction = {
  name: "",
  description: "",
  amount: 0,
  frequency: -99,
  startDate: "",
  endDate: "",
  applicationDate: "",
  status: "activo",
};

export const FrequencyList = [
  { id: 1, name: "Quincenal" },
  { id: 2, name: "Mensual" },
  { id: 3, name: "Anual" },
  { id: 4, name: "Único" },
];

export const DeductionFilled = {
  name: "",
  description: "",
  amount: 0,
  frequency: -99,
  startDate: "",
  endDate: "",
  applicationDate: "",
  status: "activo",
};